import { Badge, ThemingProps, HTMLChakraProps } from '@chakra-ui/react';
import { useQuery } from '@tanstack/react-query';
import { FC, Fragment } from 'react';

import { ResourceType } from '@/enums/ResourceType';
import { useQueryParams } from '@/hooks/useQueryParams';
import { unreadNotificationsQueryOptions } from '@/queries/upgrade/notifications';
import { StringParam } from '@/utils/url-query-string';

interface INotificationBadgeProps extends HTMLChakraProps<'div'> {
  refreshInterval?: number;
  resourceType?: ResourceType | Array<ResourceType>;
  showCount?: boolean;
  positioning?: 'inline' | 'absolute';
  size?: ThemingProps<'Badge'>['size'];
}

export const NotificationBadge: FC<INotificationBadgeProps> = ({
  children,
  showCount,
  positioning = 'absolute',
  size = 'xs',
  refreshInterval = 60 * 1000,
  resourceType,
  ...rest
}) => {
  const { eventId } = useQueryParams<{ eventId: string }>({
    eventId: StringParam,
  });

  const { data } = useQuery(unreadNotificationsQueryOptions(eventId, resourceType, undefined, refreshInterval));

  const unreadCount = data?.totalUnreadCount ?? 0;

  const badgeStyles =
    positioning === 'absolute'
      ? {
          top: '0.875rem',
          right: '0.875rem',
          position: 'absolute',
        }
      : null;

  return (
    <Fragment>
      {unreadCount > 0 && (
        <Badge sx={{ ...badgeStyles }} size={size} {...rest}>
          {showCount && unreadCount}
        </Badge>
      )}
      {children}
    </Fragment>
  );
};
